import React from 'react';
import {withRouter} from 'react-router-dom';
import { withStyles } from 'tss-react/mui';
import {FormattedMessage, injectIntl} from 'react-intl';

const ForewordToSign = (props) => {
  const {classes} = props;
  return (
    <div className={classes.div}>
      <FormattedMessage tagName='div' id='secure.payment.foreword.to.docusgin'/>
    </div>
  );
};

const useStyles = theme => ({
  div: {
    alignItems: 'center',
    color: theme.palette.secondary.main,
    display: 'flex',
    fontSize: theme.typography.pxToRem(70),
    fontWeight: 'bold',
    height: '50vh',
    justifyContent: 'center',
    textAlign: 'center',

  },
});

export default withRouter(withStyles(injectIntl(ForewordToSign), useStyles));
